module.exports = __webpack_public_path__ + "img/pen-suit (3).ec5ad4e4.png";